import { FieldErrors, UseFormRegister } from "react-hook-form";
import { Usuarios } from "../types/UsuariosTipo";

interface FormModalTypes {
  register: UseFormRegister<any>;
  usuario?: Usuarios;
  disabled?: boolean;
  formEdit?: boolean;
  errors?: FieldErrors<any>;
}

export function FormModalUser({ register, usuario, disabled, formEdit, errors }: FormModalTypes) {

  return (
    <form className="w-[25rem]">
      <div>
        <label htmlFor="Login">
          Usuário/Login<span className="text-error">*</span>
          <input
            type="text"
            {...register("Login", {required: !usuario?.Login ? true : false, pattern: /(^[a-zA-Z0-9]+$)/})}
            name="Login"
            maxLength={50}
            defaultValue={usuario?.Login}
            disabled={formEdit && true}
            className={`input-login-style mb-5 disabled:text-gray-400 ${errors?.Login && 'focus:outline-none focus:ring-2 focus:ring-error'}`}
            pattern="[a-zA-Z0-9]+"
          />
          {errors?.Login?.type === 'pattern' && <span className="absolute mt-[-1.30rem] text-error">O Login não pode conter caracteres especiais.</span>}
        </label>

        {!formEdit ? null
        : <label htmlFor="checked-toggle" className="inline-flex relative items-center cursor-pointer mb-3">
            <input type="checkbox" {...register("Ativo")} name="Ativo" disabled={disabled} id="checked-toggle" className="sr-only peer" defaultChecked={usuario?.Ativo} />
            <div className="w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-300 
            peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
            after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 
            after:border after:rounded-full after:h-5 after:w-5 after:transition-all 
            dark:border-gray-600 peer-checked:bg-primary-hover"></div>
            <span className="ml-3">Usuário Ativo?</span>
          </label>
        }
        
      </div>
      <label htmlFor="Senha">
        {!formEdit ? 'Senha' : 'Alterar Senha'}<span className="text-error">*</span>
        <input
          type="password"
          {...register("Senha", {required: !formEdit ? true : false, minLength: 4, maxLength: 18})}
          minLength={4}
          maxLength={18}
          name="Senha"
          disabled={disabled}
          className={`input-login-style mb-5 ${errors?.Senha && 'focus:outline-none focus:ring-2 focus:ring-error'}`}
        />
        {errors?.Senha?.type === 'minLength' && <span className="absolute mt-[-1.30rem] text-error">A senha deve ter no mínimo 4 dígitos</span>}
      </label>
      <span className="absolute mt-1 text-error">Campos com * são obrigatórios</span>
    </form>
  );
}
